import React, { useState, useEffect } from "react";
import {
  CardElement,
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,

} from '@stripe/react-stripe-js';
import { Actions as PAYMENTACTIONS } from '../../../store/actions/paymentActions';
import { connect } from 'react-redux';
import { ArrowDownTrayIcon } from "@heroicons/react/20/solid";
import Spinner from "../Spinner";

const CARD_OPTIONS = {
  hidePostalCode: true,
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: '#666',
      color: '#000',
      fontWeight: 500,
      fontFamily: 'Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': { color: '#666' },
      '::placeholder': { color: '#666' },
    },
    invalid: {
      iconColor: 'red',
      color: 'red',
    },
    valid: {
      iconColor: 'green',
      color: 'green',
    },
  },
};

const CheckoutForm = ({
  stripePromise,
  processingStripeCharge,
  paymentIntent,
  invoiceNo,
  onSubmit,

  businessDetails,
  selectedBundle,
  stripeCustomerID,

  stripeIntent,
  getStripeIntent,
  getStripePaymentMethods,
  clearBundle,
  cancelNewCard,
  setSavingCard,
  currency,
  processStripeCharge,
  createStripeCharge,
  savingCard,
  hasPaymentMethods,
}) => {


  const on3DSComplete = async (intent, secret) => {
    // Check the PaymentIntent

    // should normally not wait as it would have already resolved
    const stripe = await stripePromise;

    stripe.retrievePaymentIntent(secret)
      .then(function (result) {
        console.log('result.paymentIntent', result.paymentIntent)

        if (result.error) {
          // PaymentIntent client secret was invalid
        } else {
          if (result.paymentIntent.status === 'succeeded') {
            // Show your customer that the payment has succeeded

            // send redux action to save intent as succeeded
            processStripeCharge(intent)

          } else if (result.paymentIntent.status === 'requires_payment_method') {
            // Authentication failed, prompt the customer to enter another payment method
          }
        }
      });
  }

  // const [sidebarOpen, setSidebarOpen] = useState(false)
  useEffect(() => {
    getStripeIntent()

    window.addEventListener('message', function (ev) {
      if (ev.data["3DS"] == true) {
        on3DSComplete(ev.data.intent, ev.data.secret);
      }
    }, false);
  }, []);


  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    // Block native form submission.
    event.preventDefault();

    if (savingCard) {
      // already saving
      return
    }

    // submit parent form eg to save personal details
    onSubmit && onSubmit()

    console.log('handleSubmitCard')

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    setSavingCard(true)

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    // const {error, paymentMethod} = await stripe.createPaymentMethod({
    //   type: 'card',
    //   card: cardElement,
    // });
    // 
    const clientSecret = stripeIntent

    const savedCard = await stripe
      .confirmCardSetup(clientSecret, {
        payment_method: {
          card: cardElement,
          // billing_details: {
          //   name: 'Jenny Rosen',
          // },
        },
      })

    console.log('savedCard', savedCard);
    createStripeCharge(savedCard.setupIntent.payment_method)

    // charge the card
  };



  if (paymentIntent && paymentIntent.status == "requires_action") {
    return (
      <div
        style={{
          minWidth: "28rem",
          //   maxWidth: 600,
          width: "100%",
        }}>
        <iframe
          src={paymentIntent.next_action.redirect_to_url.url}
          // width={600}
          height={400}
        />
      </div>
    )
  }

  return (

    <div>

      <div className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
        style={{
        }}>
        <CardElement options={CARD_OPTIONS} />
      </div>


      <div className="mt-5">
        <a className="btn btn-success"
          onClick={handleSubmit}
          style={{ marginTop: 10 }}>
          {savingCard
            ?
              <Spinner
                style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                className="animate-spin -ml-1 mr-3 h-5 w-5 "
              />
            :
              <ArrowDownTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
          }
          <div style={{float: 'left'}}>
            {
              processingStripeCharge 
              ?
                `Processing Payment`
              :
                savingCard 
                ?
                  `Saving Card Details`
                :
                  `PAY ${currency} ${selectedBundle.price * 1.18} incl. VAT`
            }
          </div>
        </a>


        <a
          className="mt-3 text-sm inline-block"
          onClick={() => hasPaymentMethods ? cancelNewCard() : clearBundle()}
          style={{
            cursor: "pointer",
            padding: "6px 0",
            color: "#999",
            cursor: "pointer",
            textAlign: "center",
            width: "100%"
          }}>
          Cancel
        </a>
      </div>

    </div>
  );
};

const mapStateToProps = (state) => {

  return {

    businessDetails: state.payment.stats && state.payment.stats.businessDetails,
    selectedBundle: state.payment.selectedBundle,
    stripeCustomerID: state.payment.stats && state.payment.stats.stripeCustomerID,
    savingCard: state.payment.stripe.savingCard,
    hasPaymentMethods: state.payment.stripe && state.payment.stripe.paymentMethods && state.payment.stripe.paymentMethods.length > 0,
    stripeIntent: state.payment.stripe.intent && state.payment.stripe.intent.client_secret,
    processingStripeCharge: state.payment.stripe && state.payment.stripe.processingCharge,
    paymentIntent: state.payment.stripe && state.payment.stripe.paymentIntent,
    invoiceNo: state.payment.invoiceNo,
    currency: state.company?.settings?.currency,

  }
}

const mapDispatchToProps = dispatch => ({
  getStripeIntent: () => dispatch(PAYMENTACTIONS.getStripePublicIntent()),
  processStripeCharge: (intentID) => dispatch(PAYMENTACTIONS.processStripeCharge(intentID)),
  createStripeCharge: (paymentMethodID) => dispatch(PAYMENTACTIONS.createStripeCharge(paymentMethodID)),


  // getStripePaymentMethods: () => dispatch(PAYMENTACTIONS.getStripePaymentMethods()),
  clearBundle: () => dispatch(PAYMENTACTIONS.selectBundle(null)),
  cancelNewCard: () => dispatch(PAYMENTACTIONS.addNewCard(false)),
  setSavingCard: (status) => dispatch(PAYMENTACTIONS.savingNewCard(status)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckoutForm) 
